import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/paginate-duck";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_VALE_PEDAGIO_TAXAS" }
);

export interface PaginateValePedagioTaxasState extends IState {
  data: any[];
}

interface ISuccessPaginateAction extends ISuccessAction {
  data: any[];
}

const INITIAL_STATE: PaginateValePedagioTaxasState = {
  data: [],
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 0,
  },
  loading: false,
  error: null,
};

const request = (state: PaginateValePedagioTaxasState) =>
  update(state, { loading: { $set: true }, error: { $set: null } });

const success = (state: PaginateValePedagioTaxasState, action: ISuccessPaginateAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateValePedagioTaxasState, action: IFailureAction) =>
  update(state, { loading: { $set: false }, error: { $set: action.error } });

const reset = () => INITIAL_STATE;

export const paginateValePedagioTaxas = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateValePedagioTaxasTypes = Types;
export const PaginateValePedagioTaxasActions = Creators;